module.exports = __webpack_public_path__ + "static/media/thumbs_up_home.94359568.png";